<template>
	<section class="profile-box">
		<div class="columns">
			<div class="column">
				<div class="box">
					<article class="media">
						<div class="media-content">
							<div class="content">
								<div class="columns">
									<div class="column">
										<p>
											<h4>{{ psychic.userName }}</h4>
											<span class="psychic-name">{{ psychic.firstName + ` ` + psychic.lastName }}</span><br>
											<span class="psychic-ext">Psychic ext: {{ psychic.ext }}</span>
									</div>
								</div>
								<ProfileNavigation />
							</div>
						</div>
					</article>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import ProfileNavigation from "./ProfileNavigation.vue"

	export default {
		components: {
			ProfileNavigation
		},
		props: {
			psychic: Object
		}
	}
</script>